export default __webpack_public_path__ + "static/media/p1.9acc85e2.png";